import api from ".."
import config from "../../config";

export const addHistory = (body, auth, setAuth) => {
  return api.post('/histories', body, auth, setAuth);
};

export const addViewHistory = (auth, setAuth) => {
	return addHistory(
		{
			primary_reference_id: config.popId,
			action_type: config.logActionView,
  	},
		auth, setAuth);
};
